import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useApi, API } from "./api";

// lh: letterhead owner {kind, id} (vendor/employer) or {none: true}; omitted = company letterhead
export function useBrandImage(kind, version = 0, publicToken = null, lh = null) {
  const api = useApi();
  const [url, setUrl] = useState(null);
  const lk = lh ? (lh.none ? "none" : lh.kind && lh.kind !== "company" ? `${lh.kind}:${lh.id}` : "") : "";
  const load = useCallback(async (alive) => {
    if (lk === "none") { setUrl(null); return; }
    try {
      const [k, id] = lk.split(":");
      const r = publicToken
        ? await axios.get(`${API}/public/slips/${publicToken}/brand/${kind}`, { responseType: "blob" })
        : lk ? await api.get(`/org/branding/${kind}?kind=${k}&id=${id}`, { responseType: "blob" })
          : await api.get(`/company/branding/${kind}`, { responseType: "blob" });
      if (alive.current) setUrl(URL.createObjectURL(r.data));
    } catch { if (alive.current) setUrl(null); }
  }, [api, kind, publicToken, lk]);
  useEffect(() => {
    const alive = { current: true };
    load(alive);
    return () => { alive.current = false; };
  }, [load, version]);
  return url;
}
